import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'

const state = {
  map: {
    centre: null, 
    zoom: null,
  }
}

export {
  state,
  actions,
  getters,
  mutations,
}

